import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserData } from 'models';
import { RootState } from 'redux/store';

export enum UserRole {
  PARTICIPANT = 'participant',
  EXHIBITOR = 'exhibitor',
}
interface UserState {
  status: string;
  data: UserData | null;
}

const initialState: UserState = {
  status: '',
  data: null,
};

export const widgetSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setUserData: (state: UserState, action: PayloadAction<UserData | null>) => {
      state.data = action.payload;
    },
  },
});

export const selectUser = (state: RootState) => state.user.data;
export const isExhibitorUser = (state: RootState) => UserRole.EXHIBITOR === state.user.data?.user_role;

export const { setUserData } = widgetSlice.actions;
export default widgetSlice.reducer;
